import React, { useEffect, useState } from 'react';
import { ActivityIndicator, ScrollView, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { event_getGolfTournamentStatistics } from '../../../store/actionsv1/events';
import { GolfTournamentStatisticsProps } from '../../../store/types/sr_svc';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { getUniqueHeaders } from './helpers';
import { Icon } from 'react-native-elements';
import Table from '../../../Componentsv1/Table';

type GolfTournamentStatsCardProps = {
    tournament_id:string
}

const GolfTournamentStatsCard = ({ tournament_id }:GolfTournamentStatsCardProps) => {
    const [ loading, setLoading ] = useState(false);
    const [ visible_round, setVisibleRound ] = useState(1);
    const [ select_round_visible, setSelectRoundVisible ] = useState(false);

    const dispatch = useDispatch();
    const golf_tournament_statistics_list:{updated:number, golf_tournament_statistics:GolfTournamentStatisticsProps[]} = useSelector((state:any) => state.event.golf_tournament_statistics_list, (left, right) => left.updated == right.updated)
    const golf_tournament_statistics = golf_tournament_statistics_list.golf_tournament_statistics.find(gt => gt.tournament_id == tournament_id)

    const hole_statistics = golf_tournament_statistics?.round_statistics.find(s => s.round_number == visible_round)?.hole_statistics

    let unique_rounds = [ ...new Set(golf_tournament_statistics?.round_statistics.map(r => r.round_number)) ]


    useEffect(() => {
        getStatsFromServer(tournament_id)
    },[tournament_id])

    const getStatsFromServer = async(tournament_id:string) => {
        setLoading(true);
        await dispatch(event_getGolfTournamentStatistics(tournament_id))
        setLoading(false);
    }


    if(!golf_tournament_statistics || loading){
        return (
            <View style={{ padding:20 }}>
                <ActivityIndicator style={{ alignSelf:'center' }} size='large' color={Colors.brand.midnight} />
            </View>
        )
    }

    return (
        <View>
            <View nativeID='round_select' style={{ padding:10, paddingBottom:0, flexDirection:'row', alignItems:'center', justifyContent:'space-between' }}>
                <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', padding:10, borderRadius:22, borderWidth:1, borderColor:Colors.brand.electric }} onPress={() => setSelectRoundVisible(true)}>
                    <Text style={{ marginRight:3 }} size={14} color={Colors.brand.electric}>Round {visible_round}</Text>
                    <Icon name='chevron-down' type='feather' color={Colors.brand.electric} size={14}/>
                </TouchableOpacity>
            </View>
            <ScrollView horizontal nativeID='hole_stats' style={{ marginTop:10 }}>
                <Table
                    keys_hidden={['sequence','number','round_number']} 
                    first_key={'hole_number'}
                    data={hole_statistics}
                />
            </ScrollView>
            {select_round_visible ?
            <View style={{ position:'absolute', top:10, left:10, minWidth:140, borderRadius:8, backgroundColor:Colors.shades.white,  shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1 }}>
                {unique_rounds.map(r => {
                    return (
                        <TouchableOpacity style={{ padding:10, borderBottomWidth:1, borderColor:Colors.shades.shade600 }} onPress={() => {
                            setSelectRoundVisible(false);
                            setVisibleRound(r)
                        }}>
                            <Text size={14} color={Colors.brand.electric} weight='regular'>Round {r}</Text>
                        </TouchableOpacity>
                    )
                })}
            </View>
            :<></>}
        </View>
    )
}

export default GolfTournamentStatsCard